import countOptionItemSelection from "./countOptionItemSelection"

const isOptionItemSelectionMaxed = (option, flatProduct) => {
  return countOptionItemSelection(option, flatProduct) >= option.maximum_pick
};

export default isOptionItemSelectionMaxed;
